import React from "react";
import {Link} from "react-router-dom";
import db from "../../firebase";  
import { useCollectionData } from "react-firebase-hooks/firestore";
import moment from "moment";

function PostPreview(props) {
    const authorsRef = db.collection("authors");
    const AuthorsQuery = authorsRef.where("name", "==", props.author);
    const [author, loading, error] = useCollectionData(AuthorsQuery);
    return (
        <div className="row post">
            {/* Featured Image of the post */}
            <div className="col-md-4 p-0">
                <Link to={`/posts/${props.title}`}><img className="postImage" src={props.featuredImg} alt="" /></Link>
            </div>
            {/* Description of the post */}
            <div className="col-md-6 col-10">
                <h3>{props.title}</h3>
                <p>{props.description.substring(0, 100)}... <Link to={`/posts/${props.title}`}>Read more</Link></p>
                <i className="far fa-clock"></i><span>&nbsp;{moment(props.time.toDate()).calendar()}</span>
            </div>
            {/* Name and face of the author */}
            <div className="col-md-2 col-2 p-0">
                <div className="container-fluid p-0">
                    {loading && <h3>Loading...</h3>}
                    {error && <h3>{error}</h3>}
                    {/* Face */}
                    <div className="row">
                        <Link to={author ? `/authors/${author[0].name}` : ""}><img className="postDp" src={author && author[0].dpSrc} alt="" /></Link>
                    </div>
                    {/* Name */}
                    <div className="row">
                        <p>{author && author[0].name}</p>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default PostPreview;